<template>
  <div class="material-pull-select-box">
    <a-button @click="show = true" type="dashed" :icon="'upload'">
      <template v-if="ids.length > 0"> 已选择{{ ids.length }}/{{ maxNum }}个视频</template>
      <template v-else>点击添加视频</template>
    </a-button>
    <a-tag @click="clearSelected" color="orange" v-if="ids.length > 0" style="margin-left:20px;cursor:pointer">
      点击清空所有视频
    </a-tag>

    <a-modal
      title="素材拉取"
      centered
      :width="990"
      :mask-closable="false"
      :visible="show"
      :confirmLoading="false"
      :bodyStyle="{ paddingBottom: '10px' }"
      @ok="complete"
      @cancel="close"
    >
      <template>
        <div class="search-wrapper" ref="search" style="margin-top: -30px;">
          <div class="title">
            <a-icon type="search" />
            数据筛选
          </div>
          <a-divider></a-divider>
          <a-space>
            <a-select
              show-search
              allow-clear
              placeholder="广告主ID"
              v-model="queryParam.advertiser_id"
              option-filter-prop="children"
              style="width: 200px"
              :filter-option="filterAdvertiserOption"
            >
              <a-select-option :value="item.advertiser_id" v-for="item in advertiserList" :key="item.advertiser_id">
                {{ item.advertiser_id }}
              </a-select-option>
            </a-select>
            <a-input allow-clear placeholder="名称" v-model="queryParam.name" />
            <a-range-picker
              v-model="dateRange"
              valueFormat="YYYY-MM-DD"
              :placeholder="['上传开始日期', '上传结束日期']"
              style="width: 240px"
              @change="onDateRangeChange"
            />
            <a-button type="primary" @click="search">查询</a-button>
            <a-button @click="resetSearch">重置</a-button>
            <a-button type="primary" @click="showPullModal" style="border:1px solid #1890ff">
              <a-icon type="cloud-download" /> 拉取
            </a-button>
            <byted-button type="success" @click="selectAll">全选</byted-button>
          </a-space>
        </div>

        <div v-if="progressList.length > 0" class="progress-notice">
          <a-alert
            v-for="task in progressList"
            :key="task.task_id"
            :message="`${task.advertiser_name} ${task.status_text} ${task.percentage}%（${task.pulled}/${task.total}）`"
            :type="task.status === 3 ? 'error' : task.status === 2 ? 'success' : 'info'"
            show-icon
            style="margin-bottom: 5px;"
          />
        </div>

        <div
          v-infinite-scroll="handleInfiniteOnLoad"
          :infinite-scroll-disabled="busy"
          :infinite-scroll-distance="100"
          class="video-select-wrapper"
        >
          <a-spin :spinning="loading" />
          <div class="list">
            <div class="empty-box" v-if="!loading && videos.length === 0">
              <a-empty />
            </div>
            <div
              class="item"
              v-for="video in videos"
              :key="video.material_id"
              @mouseenter="preview(video)"
              @mouseleave="hidePreview()"
              @click="changeVideoId(video)"
            >
              <a-tooltip>
                <template slot="title">
                  {{ video.filename }}
                </template>
                <img :src="video.poster_url" :alt="video.name" :class="[
                  videoSelected(video) ? 'active' : '',
                  video.width && video.height && (video.width / video.height) > 1 ? 'landscape' : ''
                ]" />
                <div class="title">
                  {{ video.filename }}
                  <a-tag color="red" class="video_sync_tag" v-if="!video.width || !video.height || (Number((video.width / video.height).toFixed(4)) !== 0.5625 && Number((video.width / video.height).toFixed(4)) !== 1.7778)">尺寸不符合</a-tag>
                </div>
                <div class="video">
                  <video
                    autoplay
                    class="video-preview"
                    rel="noreferrer"
                    :src="currentVideo ? currentVideo.url : ''"
                    v-if="currentVideo && currentVideo.material_id === video.material_id"
                  />
                </div>
              </a-tooltip>
            </div>
          </div>
        </div>
      </template>

      <a-modal
        title="拉取素材"
        :visible="pullModalVisible"
        :confirm-loading="pullLoading"
        @ok="handlePull"
        @cancel="pullModalVisible = false"
        width="450px"
      >
        <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item label="广告主ID">
            <a-select
              mode="combobox"
              allow-clear
              v-model="pullForm.advertiser_id"
              placeholder="选择或输入广告主ID"
              option-filter-prop="children"
              style="width: 100%"
              :filter-option="filterAdvertiserOption"
            >
              <a-select-option :value="item.advertiser_id" v-for="item in advertiserList" :key="item.advertiser_id">
                {{ item.advertiser_id }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="开始日期">
            <a-date-picker v-model="pullForm.start_date" valueFormat="YYYY-MM-DD" style="width: 100%" />
          </a-form-model-item>
          <a-form-model-item label="结束日期">
            <a-date-picker v-model="pullForm.end_date" valueFormat="YYYY-MM-DD" style="width: 100%" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ offset: 6 }">
            <span style="color: #999; font-size: 12px;">最大拉取3天数据</span>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </a-modal>
  </div>
</template>

<style lang="less" scoped>
@import 'MaterialPullSelect';
</style>

<script>
import MaterialPullSelect from './MaterialPullSelect'
export default MaterialPullSelect
</script>
